import { SET_STATE_DISABLE } from '../actions/disableActions';
const initial_state= {
  disable: false
};

export const disableReducer = (state = initial_state, action) => {
  switch (action.type) {
    case SET_STATE_DISABLE: 
      return {
        ...state,
        disable: action.payload
      };
    default: 
      return {...state};
  }
};